import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { CreateSpaceQuery } from './CreateSpaceQuery.graphql';

type PreloadCreateSpaceOptions = {
	isLicensed: boolean;
};

export const preloadCreateSpace = ({
	isLicensed,
}: PreloadCreateSpaceOptions): Promise<{ data: unknown }> => {
	if (!isLicensed) {
		return Promise.resolve({ data: null });
	}

	/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
	return query({ query: CreateSpaceQuery });
};
